/**
 * Rauszeit Feature Popup Modal System
 * Elegant, minimal design with custom SVG icons
 */

(function() {
  'use strict';

  // ==========================================
  // GOOGLE REVIEWS SHADOW DOM STYLING
  // Inject custom styles into CarthiKe widget
  // ==========================================
  function styleGoogleReviews() {
    const reviewsContainer = document.getElementById('carthike-carousel-div');
    if (!reviewsContainer) return;

    // Find the shadow root
    const shadowRoot = reviewsContainer.shadowRoot;
    if (!shadowRoot) {
      // Try again later if shadow root isn't ready
      setTimeout(styleGoogleReviews, 500);
      return;
    }

    // Check if we already injected styles
    if (shadowRoot.querySelector('#rauszeit-reviews-style')) return;

    // Create style element
    const style = document.createElement('style');
    style.id = 'rauszeit-reviews-style';
    style.textContent = `
      /* Wrapper */
      .carousel-wrapper {
        padding: 20px 70px 40px 70px !important;
        max-width: 1400px !important;
        margin: 0 auto !important;
        position: relative !important;
      }

      /* Header - CENTERED */
      .carousel-header-container {
        padding: 0 20px 28px 20px !important;
        margin-bottom: 16px !important;
        text-align: center !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .carousel-header-container > div {
        text-align: center !important;
      }

      .carousel-header-container h2 {
        font-family: 'Work Sans', sans-serif !important;
        font-weight: 800 !important;
        font-size: 1.5rem !important;
        color: #02192f !important;
        text-transform: uppercase !important;
        letter-spacing: 1px !important;
        text-align: center !important;
      }

      /* Hide write review button if empty */
      .write-review-button:empty {
        display: none !important;
      }

      /* Carousel container */
      #carousel {
        overflow-x: auto !important;
        padding: 16px 10px 24px 10px !important;
        gap: 16px !important;
        scroll-snap-type: x mandatory !important;
      }

      /* Review Cards - Clean design */
      .carousel-card {
        flex: 0 0 300px !important;
        width: 300px !important;
        min-height: 320px !important;
        margin: 8px 10px !important;
        border-radius: 16px !important;
        border: 1px solid rgba(0, 0, 0, 0.06) !important;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06) !important;
        transition: all 0.3s ease !important;
        scroll-snap-align: start !important;
        overflow: hidden !important;
        background: #ffffff !important;
      }

      .carousel-card:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
        transform: translateY(-4px) !important;
        border-color: rgba(0, 80, 72, 0.15) !important;
      }

      /* Profile images */
      .carousel-card img {
        width: 52px !important;
        height: 52px !important;
        border-radius: 50% !important;
        border: 2px solid #c0dd90 !important;
        box-shadow: none !important;
      }

      /* Star container */
      .star-container {
        background: #fffbeb !important;
        border-radius: 16px !important;
        padding: 5px 12px !important;
        box-shadow: none !important;
        border: 1px solid rgba(251, 191, 36, 0.2) !important;
      }

      .rating-stars {
        font-size: 0.9rem !important;
        letter-spacing: 1px !important;
      }

      /* Names */
      .carousel-card .font-semibold {
        color: #02192f !important;
        font-family: 'Work Sans', sans-serif !important;
        font-size: 1.05rem !important;
        font-weight: 600 !important;
      }

      /* Dates */
      .carousel-card .text-xs.mb-2 {
        color: #9ca3af !important;
        font-size: 0.75rem !important;
      }

      /* Review text */
      .review-text {
        color: #4b5563 !important;
        font-size: 0.9rem !important;
        line-height: 1.6 !important;
      }

      /* Read more button */
      .text-blue-600 {
        color: #005048 !important;
        font-weight: 600 !important;
        font-size: 0.85rem !important;
        transition: color 0.2s ease !important;
      }

      .text-blue-600:hover {
        color: #f44224 !important;
      }

      /* Navigation Arrows - VERTICALLY CENTERED on cards */
      #prevBtn, #nextBtn {
        background: #02192f !important;
        color: #ffffff !important;
        border-radius: 50% !important;
        width: 48px !important;
        height: 48px !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
        transition: all 0.3s ease !important;
        z-index: 100 !important;
        position: absolute !important;
        top: calc(50% + 40px) !important;
        transform: translateY(-50%) !important;
      }

      #prevBtn {
        left: 10px !important;
      }

      #nextBtn {
        right: 10px !important;
      }

      #prevBtn:hover, #nextBtn:hover {
        background: #005048 !important;
        transform: translateY(-50%) scale(1.08) !important;
        box-shadow: 0 4px 12px rgba(0, 80, 72, 0.25) !important;
      }

      #prevBtn svg, #nextBtn svg {
        width: 24px !important;
        height: 24px !important;
        stroke: white !important;
      }

      /* Mobile */
      @media (max-width: 749px) {
        .carousel-wrapper {
          padding: 10px 0 20px 0 !important;
          overflow: visible !important;
        }

        .carousel-header-container {
          padding: 0 16px 16px 16px !important;
          margin-bottom: 8px !important;
        }

        .carousel-header-container h2 {
          font-size: 1.2rem !important;
        }

        #carousel {
          padding: 8px 16px 16px 16px !important;
          gap: 12px !important;
          overflow-x: auto !important;
          scroll-padding-left: 16px !important;
        }

        .carousel-card {
          flex: 0 0 calc(100vw - 80px) !important;
          width: calc(100vw - 80px) !important;
          max-width: 300px !important;
          min-height: auto !important;
          margin: 4px 0 !important;
          padding: 16px !important;
        }

        .carousel-card img {
          width: 44px !important;
          height: 44px !important;
        }

        .star-container {
          padding: 3px 8px !important;
        }

        .rating-stars {
          font-size: 0.8rem !important;
        }

        .carousel-card .font-semibold {
          font-size: 0.95rem !important;
        }

        .review-text {
          font-size: 0.85rem !important;
          line-height: 1.5 !important;
        }

        #prevBtn, #nextBtn {
          display: none !important;
        }
      }
    `;

    shadowRoot.appendChild(style);
    console.log('Rauszeit: Google Reviews styles injected into Shadow DOM');
  }

  // Run when DOM is ready and after a delay for dynamic content
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(styleGoogleReviews, 1000);
    });
  } else {
    setTimeout(styleGoogleReviews, 1000);
  }

  // Also observe for dynamic insertion
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        const reviewsDiv = document.getElementById('carthike-carousel-div');
        if (reviewsDiv && reviewsDiv.shadowRoot) {
          styleGoogleReviews();
          observer.disconnect();
          break;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ==========================================
  // END GOOGLE REVIEWS STYLING
  // ==========================================

  // Feature popups are now handled by section-feature-grid.liquid
  // All modal content is editable via the Shopify theme editor
})();
